
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
// import { useEffect } from 'react'
import { IDadosAlterados } from '../..'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
interface IGraficoCampos{

  id: string
  listaCamposAlterados: IDadosAlterados[]
  escala: number
  onChoiceCampo: (dataPoint: number, serie: string) => void

}

export const GraficoCamposAlterados: React.FC<IGraficoCampos> = ({ id, listaCamposAlterados, escala, onChoiceCampo }) => {
  function GerarGrafico(): void {
    // const arrayQuantidade = listaCamposAlterados.map(item => item.quantidade)
    const arrayPercentual = listaCamposAlterados.map(item => item.percentual.toFixed(2))
    const arrayCampo = listaCamposAlterados.map(item => item.campo)

    const options = {
      series: [
        // {
        //   name: 'Total perfis',
        //   data: [total, analisados, aderenciaOriginal, calibradosAderencia]
        // },
        {
          name: '',
          data: arrayPercentual
        }
      ],

      // labels: ['Aderentes', 'Aderentes com ressalvas', 'Não aderentes'],
      chart: {
        type: 'bar',
        horizontal: true,
        // height: 650,
        width: 900,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            console.log(opts)
            onChoiceCampo(opts.dataPointIndex, arrayCampo[opts.dataPointIndex])
          },
          onClick: function (_event: any, chartContext: any, config: any) {
            const serieIndex = config.seriesIndex
            const dataPointIndex = config.dataPointIndex

            const categoria = arrayCampo[dataPointIndex]
            const valor = arrayPercentual[serieIndex]

            alert(`Clique em: ${categoria} de ${serieIndex} /${dataPointIndex} = ${valor}`)
          }
        }
      },
      // grid: {
      //   padding: {
      //     left: 200 // aumenta a área onde os textos das categorias aparecem
      //   }
      // },

      colors: ['#19dbc4', '#2744ae', '#62dc21', '#e6d51b'],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            formatter: function(val: any, opt: any) {
              return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val + '%'
            },
            offsetX: 0
            // total: {
            //   enabled: true,
            //   offsetX: 0,
            //   style: {
            //     fontSize: '8px',
            //     fontWeight: 900
            //   }
            // }
          }
        }
      },
      // stroke: {
      //   width: 1,
      //   colors: ['#fff']
      // },
      title: {
        text: 'Ranking Campos alterados (%)'
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
          colors: ['#000000']
        },
        formatter: function (val: any, opt: any) {
          // return val + ' %'
          return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val + '%'
        },
        offsetX: 5
        // dropShadow: {
        //   enabled: true
        // }
      },
      xaxis: {
        categories: arrayCampo,
        // labels: arrayCampo,
        min: 0,
        max: escala

      },
      yaxis: {
        labels: {
          show: false
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val + '%'
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [listaCamposAlterados, escala])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
